import { Marketplace } from 'app/graphql/generated/admin/graphql';

export function getFallbackImageDomain(domain: string, marketplace: Marketplace) {
  if (marketplace === Marketplace.Shopify) {
    return 'shopify.com';
  }
  return domain;
}

export function formatNumberShort(num: number, decimals = 1): string {
  if (num === null || num === undefined || isNaN(num)) {
    return '0';
  }
  const absNum = Math.abs(num);
  const sign = num < 0 ? '-' : '';
  if (absNum < 1_000) {
    return `${num}`;
  }
  const units = [
    { value: 1_000_000_000_000, symbol: 'T' },
    { value: 1_000_000_000, symbol: 'B' },
    { value: 1_000_000, symbol: 'M' },
    { value: 1_000, symbol: 'K' },
  ];
  for (const unit of units) {
    if (absNum >= unit.value) {
      const formatted = (absNum / unit.value).toFixed(decimals).replace(/\.0+$/, '');
      return `${sign}${formatted}${unit.symbol}`;
    }
  }
  return `${num}`;
}

export function createFallbackImageUrl(url: string, marketplace: Marketplace) {
  try {
    const hostname = new URL(url).hostname;
    return `https://logo.clearbit.com/${getFallbackImageDomain(hostname, marketplace)}`;
  } catch {
    return `https://logo.clearbit.com/${getFallbackImageDomain('', marketplace)}`;
  }
}
